import routes from 'constants/routes';
import { HomeCard } from './types';

export const administracionCardData: HomeCard[] = [
	{
		id: 201,
		icon: '🛒',
		title: 'Listado de sale orders',
		description: 'Buscá y accedé a órdenes de venta.',
		link: routes.salesOrder.list,
		isExternal: false,
	},
	{
		id: 202,
		icon: '🚌',
		title: 'Listado de servicios',
		description: 'Órdenes de venta con servicios (hoteles, transfers, etc.).',
		link: routes.salesOrder.serviceList,
		isExternal: false,
	},
	{
		id: 203,
		icon: '🎫',
		title: 'Tickets de vuelos y ancillaries',
		description: 'Consultá y gestioná tickets de vuelos y servicios ancillaries.',
		link: routes.operations.flightAndAncillaryTickets,
		isExternal: false,
	},
	{
		id: 204,
		icon: '👥',
		title: 'Clientes',
		description: 'Listado y gestión de clientes.',
		link: routes.customers.list,
		isExternal: false,
	},
	{
		id: 205,
		icon: '💳',
		title: 'Transacciones C2A',
		description: 'Listado y gestión de transacciones card-to-airline.',
		link: routes.transactions.listV2,
		isExternal: false,
	},
	{
		id: 206,
		icon: '🏭',
		title: 'Proveedores',
		description: 'Listado y gestión de proveedores.',
		link: routes.providers.list,
		isExternal: false,
	},
	{
		id: 207,
		icon: '📋',
		title: 'Órdenes de compra',
		description: 'Listado de órdenes de compra a proveedores.',
		link: routes.providerPayments.list,
		isExternal: false,
	},
	{
		id: 208,
		icon: '💰',
		title: 'Pago a proveedores',
		description: 'Registrar y gestionar pagos a proveedores.',
		link: routes.providerPayments.payments,
		isExternal: false,
	},
	{
		id: 211,
		icon: '📅',
		title: 'Agenda de pagos',
		description: 'Vencimientos programados de pagos a proveedores agrupados por fecha.',
		link: routes.providerPayments.schedule,
		isExternal: false,
	},
	{
		id: 209,
		icon: '📥',
		title: 'Importar pagos masivo',
		description: 'Importación masiva de pagos a proveedores.',
		link: routes.providerPayments.bulk,
		isExternal: false,
	},
	{
		id: 210,
		icon: '🧾',
		title: 'Cobros y recibos a clientes',
		description: 'Listado de cobros y recibos emitidos a clientes.',
		link: routes.clientPayments.list,
		isExternal: false,
	},
];
